import DataPartnershipsPage from "@/components/marketing/products/data-partnerships/DataPartnershipsPage"

type Props = {}

const index = (_props: Props) => {
  return <DataPartnershipsPage />
}

export default index
